import { Stack, Typography } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';

import { IOfferLetter } from '../../type';
import Header from '../header';
import DateAddress from '../date-address';
import { PdfPage } from '../pdf-page';
import { useRequestState } from '@app/hooks';
import { selectAddOfferLetterState } from '../../selectors';

interface Props {
  methods: UseFormReturn<IOfferLetter>;
}

const OfferLetter = ({ methods }: Props) => {
  const { data } = useRequestState({
    stateSelector: selectAddOfferLetterState,
    successMessageShown: true,
    errorShown: true,
  });

  return (
    <PdfPage>
      <Header />

      <DateAddress
        fullName={data?.name}
        joiningDate={data?.date}
        address={data?.address}
        contraction={data?.contraction}
      />

      <Typography variant="subtitle2" py={5} textAlign="center" sx={{ fontFamily: 'Verdana' }}>
        Subject: OFFER LETTER
      </Typography>

      <Stack gap={1.5}>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          Dear<b> {data?.name}, </b>
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          Congratulations! We are pleased to confirm that you have been selected to work for
          SyncGlob Pvt. Ltd. We are confident that SyncGlob will provide you with an exceptional
          work environment that fosters growth and continuous learning, leading to your ongoing
          success.
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          The position we are offering you is that
          <b>{` ${String(data?.position)},`}</b>
          at monthly salary of INR <b>{`${String(data?.salary)},`}</b>
          with an annual cost to company INR
          <b> {`${Number(data?.salary) * 12}/-`}</b>. Your working hours will be from 9.30 AM to
          6.30 PM, Monday to Friday.
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          By accepting the offer, you also express your consent to the company policies, existing as
          well as the ones created/modified during your employment with us. This offer is liable to
          lapse in case we do not receive your acceptance in writing/e-mail within 3 days. We commit
          ourselves to provide you an exciting and rewarding career and look forward to your valued
          contribution to the growth of the company.
        </Typography>
        <Typography variant="subtitle1" sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          Your Sincerely
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>SyncGlob Pvt. Ltd.</Typography>
      </Stack>
      <Stack justifyContent={'end'} alignItems={'start'}>
        <Stack width={150} mt={'20px'}>
          <img src={'/assets/images/jatin-soni.png'} />
        </Stack>
        -----------------------------
      </Stack>
    </PdfPage>
  );
};

export default OfferLetter;
